import React from 'react';
import { Box, Typography } from '@mui/material';
import PageGuideTooltip from '../PageGuideTooltip';

// Shared title block for the Executive Summary and Deep Dive pages: title + guide tooltip and
// the uppercase subtitle on the left, action buttons on the right.
export default function ExecPageHeader({ title, subtitle, guide, actions }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1.5, flexWrap: 'wrap' }}>
      <Box sx={{ flexGrow: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>{title}</Typography>
          <PageGuideTooltip {...guide} />
        </Box>
        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, letterSpacing: 0.5, textTransform: 'uppercase' }}>
          {subtitle}
        </Typography>
      </Box>
      {actions}
    </Box>
  );
}
